import React, { useState, useEffect } from 'react';
import useBodyClass from 'helpers/hooks/useBodyClass';
import List from 'screens/Panel/screens/Firm/screens/Managers/components/List/List';
import styles from 'screens/Panel/screens/Firm/screens/Managers/Managers.module.scss';
import { fetchManagers, updateManagerStatus } from 'screens/Panel/screens/Firm/screens/Managers/api';
import { Manager } from 'screens/Panel/screens/Firm/screens/Managers/api/types';
import { Nullable } from 'utils/types';

const Managers: React.FC<any> = ({ match }) => {
  const [managers, setManagers] = useState<Manager[]>([]);
  const [firmName, setFirmName] = useState<string>('');
  const [managersCount, setManagersCount] = useState<Nullable<number>>(null);

  const firmId = match.params.id;

  useBodyClass(...styles['new-cm'].split(' '));

  useEffect(() => {
    fetchManagers(firmId).then(({ data }) => {
      const sortedManagersArray = data.sort((a, b) => a.firstName.localeCompare(b.firstName));

      setFirmName(data[0].company.name);
      setManagers(sortedManagersArray);
      setManagersCount(data.length);
    });
  }, [firmId]);

  const prepareRows = (items: Manager[]) => {
    return items.map((item: Manager, index: number) => ({
      key: item.id.toString(),
      data: [
        { label: `${item.firstName} ${item.lastName}`, link: { href: `/bp/user/${item.id}` } },
        { label: item.email },
        { label: item.company.fcaNumber },
        { label: item.role },
        { label: item.city },
        { label: item.isVerified ? 'Unverify' : 'Verify', action: () => handleManagerStatusChange(item, index) },
      ],
    }));
  };

  const handleManagerStatusChange = async (manager: Manager, index: number) => {
    const isVerified = !manager.isVerified;

    await updateManagerStatus(manager.id, isVerified);

    setManagers((previousState) => {
      const copy = [...previousState];
      copy[index].isVerified = isVerified;
      return copy;
    });
  };

  return (
    <>
      <div className={styles.heading}>
        <p className={styles.title}>
          {firmName}
          {managersCount && <span className={styles.managersCount}> {`(${managersCount})`}</span>}
        </p>
      </div>
      <div>
        <List
          labels={['Name', 'Email', 'FCA Number', 'Permissions', 'Location', 'Action']}
          rows={prepareRows(managers)}
          onAction={() => {}}
        />
      </div>
    </>
  );
};

export default Managers;
